import React from 'react';

const Press: React.FC = () => {
  const pressData = [
    {
      category: "Voxel Earth",
      articles: [
        {
          title: "Google Earth Transformed: Building a New World",
          publisher: "SIGGRAPH Blog",
          date: "4 June 2024",
          link: "https://blog.siggraph.org/2024/06/google-earth-transformed-building-a-new-world.html/",
          image: "https://blog.siggraph.org/wp-content/uploads/2024/06/coverwithattribution.jpg",
        },
        {
            title: "Mad with power, researcher and Minecraft fan creates a way to voxelize the whole world",
            publisher: "PC Gamer",
            date: "23 June 2024",
            link: "https://www.pcgamer.com/games/survival-crafting/mad-with-power-researcher-and-minecraft-fan-creates-a-way-to-voxelize-the-whole-world/",
            image: "https://cdn.mos.cms.futurecdn.net/hqTgqvNh6E7fbmoe5MwaEE-650-80.png.webp",
          },
          {
            title: "Minecraft fan makes Google Earth explorable in the game",
            publisher: "TechSpot",
            date: "24 June 2024",
            link: "https://www.techspot.com/news/103527-minecraft-fan-makes-google-earth-explorable-game.html",
            image: "https://www.techspot.com/images2/news/bigimage/2024/06/2024-06-24-image-35-j_1100.webp",
          },
          {
            title: "リアル世界を『マイクラ』で再現！？Googleマップの3Dタイルをボクセルに変換する技術を開発",
            publisher: "Yahoo! Japan",
            date: "24 June 2024",
            link: "https://web.archive.org/web/20240714034758/https://news.yahoo.co.jp/articles/93effd4f13e67f9de6279f3fd81f2a45ea813ea6",
            image: "https://web.archive.org/web/20240714033141/https://news-pctr.c.yimg.jp/r/iwiz-tpc/images/tpc/eternal/2017/10/27/1509081692_1427194511_1427194505_topics550x550.jpg",
          },
      ],
    },
    {
      category: "Treefolio",
      articles: [
        {
          title: "These are the neighbourhoods in most urgent need of trees",
          publisher: "BBC Future",
          date: "16 April 2024",
          link: "https://www.bbc.com/future/article/20240415-why-cities-should-plant-trees-with-racial-equity-in-mind",
          image: "https://ichef.bbci.co.uk/images/ic/1024xn/p0hqzkgj.jpg.webp",
        },
        {
          title: "Tree Folio NYC Aims to Monitor Urban Forest in Real Time",
          publisher: "Planetizen",
          date: "11 January 2024",
          link: "https://www.planetizen.com/news/2024/01/127014-tree-folio-nyc-aims-monitor-urban-forest-real-time",
          image: "https://www.planetizen.com/files/styles/featured_large/public/images/AdobeStock_63635646.jpeg.webp?itok=5FCBhUVV",
        },
        {
          title: "Researchers advocate for new tech to revolutionize NYC infrastructure, and it's likely not what you think",
          publisher: "The Cooldown",
          date: "7 January 2024",
          link: "https://www.thecooldown.com/green-business/tree-folio-nyc-urban-trees-benefits/",
          image: "https://www.thecooldown.com/wp-content/uploads/2024/01/yaKYMaGRcXTW.jpg?w=1920&h=800",
        },
        {
          title: "When It Comes to Urban Trees, More Isn't Always Better",
          publisher: "Bloomberg CityLab",
          date: "9 October 2023",
          link: "https://www.thecooldown.com/green-business/tree-folio-nyc-urban-trees-benefits/",
          image: "https://s3.divcom.com/www.geoweeknews.com/images/shutterstock_388635820_650x434.jpeg.large.1024x1024.jpg",
        },
        {
          title: "Digital twins in the fight to mitigate urban heat islands",
          publisher: "Geo Week News",
          date: "5 September 2023",
          link: "https://www.geoweeknews.com/news/tree-folio-new-york-city-urban-heat-island-digital-twin-cornell-gis",
          image: "https://scx1.b-cdn.net/csz/news/800a/2022/urban-trees.jpg",
        },
        {
          title: "A 3D interactive map of the shade provided by every single NYC street tree",
          publisher: "The Washington Post",
          date: "26 August 2023",
          link: "https://boingboing.net/2023/08/28/a-3d-interactive-map-of-the-shade-provided-by-every-single-nyc-street-tree.html",
          image: "https://i0.wp.com/boingboing.net/wp-content/uploads/2023/08/Screen-Shot-2023-08-27-at-7.59.52-AM.png?fit=1&ssl=1&resize=620%2C4000",
        },
        {
          title: "New Yorkers, how much shade does your street really have? This map will tell you.",
          publisher: "Gothamist",
          date: "21 August 2023",
          link: "https://gothamist.com/news/new-yorkers-how-much-tree-shade-does-your-street-really-have-this-map-will-tell-you",
          image: "https://images-prod.gothamist.com/images/202308.2e16d0ba.fill-700x467.format-webp.webpquality-70_7bmJrHY.webp",
        },
        {
          title: "Throwing shade: Model maps NYC street trees' cooling benefits",
          publisher: "Phys.org",
          date: "14 August 2023",
          link: "https://phys.org/news/2023-08-nyc-street-trees-cooling-benefits.html",
          image: "https://scx1.b-cdn.net/csz/news/800a/2022/urban-trees.jpg",
        },
      ],
    },
    {
      category: "Fire and Smoke Digital Twin",
      articles: [
        {
            title:"With FEMA support disappearing, what should cities do to combat natural disasters?",
            publisher: "Fast Company",
            date: "28 July 2025",
            link: "https://www.fastcompany.com/91360394/with-reduced-fema-support-what-should-cities-do-to-prevent-natural-disasters-fema-cities-natural-disasters",
            image: "https://images.fastcompany.com/image/upload/f_webp,c_fit,w_1920,q_auto/wp-cms-2/2025/07/p-1-91360394-Impact-With-reduced-FEMA-support-what-should-cities-do-to-prevent-natural-disasters-.jpg"
        },
        {
          title: "How artificial intelligence is making cities smarter",
          publisher: "The Drag Audio Production House",
          date: "23 April 2024",
          link: "https://pod.link/1731843187/episode/4fe537ba13171e0868826e9252a05871",
          image: "https://thedragaudio.com/wp-content/uploads/2023/09/drag-new-logo-203x100-1.png",
        },
        {
            title:"How Digital Twins Can Help Cities Build Resilience",
            publisher: "Bloomberg",
            date: "13 October 2023",
            link: "https://www.youtube.com/watch?v=p0hMlNyugCk",
            image: "https://images-ext-1.discordapp.net/external/sULFjsNLjsWM1Q_nCKqNOTIufcfa_rZSwnnfF16kW3o/https/img.youtube.com/vi/p0hMlNyugCk/0.jpg?format=webp&width=600&height=450"
        },
        {
          title: "Project to Tackle Effects of Extreme Climate Unveiled by Doggett, UT and City of Austin",
          publisher: "UT News",
          date: "7 September 2023",
          link: "https://news.utexas.edu/2023/09/07/project-to-tackle-effects-of-extreme-climate-unveiled-by-doggett-ut-and-city-of-austin/",
          image: "https://news.utexas.edu/wp-content/uploads/2023/09/LBJ-School-Doggett-presser-wide-211-1-1200x800-c-default.jpg",
        },
        {
          title: "UT-Austin researchers partner with Austin Fire Department to predict, map smoke impact on communities",
          publisher: "The Daily Texan",
          date: "8 February 2023",
          link: "https://thedailytexan.com/2023/02/08/ut-austin-researchers-partner-with-austin-fire-department-to-predict-map-smoke-impact-on-communities/",
          image: "https://thedailytexan.com/wp-content/uploads/2023/02/2-7-23_AustinFire_ElizabethAguilar-Garcia-900x696.jpeg",
        },
      ],
    },
    {
      category: "Houston Food Deserts",
      articles: [
        {
          title: "University of Houston using Artificial Intelligence to combat food insecurity",
          publisher: "FOX 26 Houston",
          date: "9 April 2023",
          link: "https://www.fox26houston.com/news/university-of-houston-using-artificial-intelligence-to-combat-food-insecurity",
          image: "https://www.fox26houston.com/img/default-image.png",
        },
        {
          title: "University researchers are using AI to fight food insecurity",
          publisher: "FoodService Director",
          date: "4 April 2023",
          link: "https://www.foodservicedirector.com/operations/university-researchers-are-using-ai-fight-food-insecurity",
          image: "https://eu-images.contentstack.com/v3/assets/blt517884d3ef6fd53e/blt454e217c84b76d45/66d984353a2397f022636d3b/Shutterstock_258367139.jpg?width=1280&auto=webp&quality=95&format=jpg&disable=upscale",
        },
        {
          title: "Project Combats Food Insecurity Through Artificial Intelligence",
          publisher: "UH News",
          date: "3 April 2023",
          link: "https://breakthrough.nsm.uh.edu/issues/summer-2023/articles/food-security",
          image: "https://uh.edu/news-events/stories/2023/april-2023/food-pantry.png",
        },
      ],
    },
  ];

  return (
    <section id="press" className="bg-gray-50 dark:bg-gray-900 py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-10">Press</h1>

        {pressData.map((project) => (
          <div key={project.category} className="mb-16">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-6">
              {project.category}
            </h2>
            <ul className="space-y-6">
              {project.articles.map((article, index) => (
                <a
                  key={index}
                  href={article.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center bg-white dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition-shadow duration-300 p-4 group"
                >
                  <div className="flex-shrink-0">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                      {article.publisher} • {article.date}
                    </p>
                  </div>
                </a>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Press;